export default __webpack_public_path__ + "static/media/big_check.66277cce.svg";